import { render, staticRenderFns } from "./DTextareaPreview.vue?vue&type=template&id=0d23da94&"
import script from "./DTextareaPreview.vue?vue&type=script&lang=js&"
export * from "./DTextareaPreview.vue?vue&type=script&lang=js&"
import style0 from "./DTextareaPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports